import React from 'react';
import { LandingComponent, SubLandingComponent } from 'app/types';

import Accordion from 'react-bootstrap/Accordion';
import { useMediaQuery } from 'react-responsive';
import styles from '../LandingForm.module.scss';

interface PreviewComponentProps {
  landing_cmp: LandingComponent;
}

interface AnswerProps {
  number: string;
  faq: SubLandingComponent;
}

const AnswerComp = ({ number, faq }: AnswerProps): React.ReactElement => {
  return (
    <Accordion.Item
      eventKey={number}
      style={{
        marginBottom: '20px',
        background: '#F2F2F2',
        fontSize: '16px',
        fontWeight: '600',
        color: '#19234F',
      }}
    >
      <Accordion.Header className={styles.accordionHeader}>
        {faq.config.faq_question}
      </Accordion.Header>
      <Accordion.Body>{faq.config.faq_answer}</Accordion.Body>
    </Accordion.Item>
  );
};

const FaqPreview = ({ landing_cmp }: PreviewComponentProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const titleSize = (size?: string) => {
    if (size === 'large') {
      return '3rem';
    } else if (size === 'normal') {
      return '30px';
    } else if (size === 'small') {
      return '18px';
    }
    return;
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: landing_cmp.size !== 'sm' && landing_cmp.size !== 'md' ? landing_cmp.size : 'auto',
        padding: landing_cmp.size === 'sm' ? '0 12rem' : '0 4vw',
        margin: landing_cmp.gap,
        background: !(landing_cmp.background instanceof File) ? landing_cmp.background : 'auto',
        backgroundSize: landing_cmp.background_size,
        backgroundImage: `url(${landing_cmp.background_image})`,
      }}
      className={landing_cmp.class_name}
      key={landing_cmp.id}
    >
      {(landing_cmp.config.title || landing_cmp.config.section_title) && (
        <div className="headerSection">
          {landing_cmp.config.section_title && (
            <div className={`${styles.sectionTitle} text-center d-flex flex-column`}>
              {landing_cmp.config.section_title}
              <div
                style={{ width: '87px', height: '8px', background: '#E8F3FE', alignSelf: 'center' }}
              ></div>
            </div>
          )}
          {landing_cmp.config.title && (
            <div
              style={{
                fontSize: titleSize(landing_cmp.config.title_size),
                color: '#193676',
                fontWeight: '700',
                textAlign: 'center',
                marginBottom: '56px',
              }}
            >
              {landing_cmp.config.title}
            </div>
          )}
        </div>
      )}
      <Accordion style={{ minWidth: !isMobile ? '100%' : 'auto' }}>
        <div className={`row row-cols-1 row-cols-md-2`}>
          {landing_cmp.sub_landing_components.map((faq) => (
            <div key={faq.id} className="col">
              <AnswerComp faq={faq} number={faq.id.toString()} />
            </div>
          ))}
        </div>
      </Accordion>
    </div>
  );
};

export default FaqPreview;
